import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as StackTrace from 'stacktrace-js';
import { IGlobalError } from '../models/global-error.model';
import { LogErrorService } from './log-error.service';
import { UserService } from '../../features/user-management/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly logErrorService = inject(LogErrorService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  logError: Partial<IGlobalError> = {
    error: '',
    message: '',
    stack: '',
    timestamp: undefined,
    url: '',
    method: '',
  };

  handleError(error: any): void {
    console.log('handle and log the error here and send it to the server');

    StackTrace.fromError(error).then((stackFrames) => {
      const importantStackFrames = stackFrames
        .filter((sf) => {
          const fileName = sf.fileName || '';
          return (
            fileName.includes('src/app/') ||
            fileName.includes('localhost') ||
            fileName.includes('your-app-name')
          );
        })
        .slice(0, 5)
        .map((sf) => ({
          function: sf.functionName || 'anonymous',
          file: sf.fileName ? sf.fileName.split('/').pop() : 'unknown', // Just filename, not full path
          line: sf.lineNumber,
          column: sf.columnNumber,
        }));

      const simplifiedStack = importantStackFrames
        .map(
          (frame) =>
            `${frame.function} (${frame.file}:${frame.line}:${frame.column})`
        )
        .join('\n');

      console.log('logError is not null');
      this.logError.error = error;
      this.logError.message = error.message || error.toString();
      this.logError.stack = simplifiedStack;
      this.logError.timestamp = new Date();
      this.logError.url = this.router.url;
      this.logError.user = this.userService.currentUser()?.name || 'default user';
      this.logErrorService.logError(this.logError);
    });
  }
}
